"use strict";
/**
 * CSV field escaping to prevent CSV injection / formula injection (CR-015)
 *
 * 管理画面のCSVエクスポートで、ユーザー制御文字列（タイトル・メール・UserAgent等）を
 * そのままセルに出力すると、先頭が `= + - @ \t \r` の値を Excel 等が数式として実行し、
 * 情報漏洩やコマンド実行（=HYPERLINK 等）につながる。さらに `"` 未エスケープでは
 * CSV構造の破壊も可能。本関数で全フィールドを安全化する。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeCsvField = escapeCsvField;
// 先頭にあると表計算ソフトが数式として解釈し得る文字
const CSV_FORMULA_TRIGGERS = ['=', '+', '-', '@', '\t', '\r'];
/**
 * CSVの1フィールドを安全にエスケープして返す（前後の `"` 囲み込み）。
 * - 先頭が式トリガー文字なら `'` を前置して数式実行を無害化
 * - `"` を `""` にエスケープ
 * - 全体を `"` で囲む
 */
function escapeCsvField(value) {
    let str = value === null || value === undefined ? '' : String(value);
    if (str.length > 0 && CSV_FORMULA_TRIGGERS.includes(str[0])) {
        str = `'${str}`;
    }
    return `"${str.replace(/"/g, '""')}"`;
}
//# sourceMappingURL=csv.js.map